import ContactUsPage from './pages/ContactUsPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import ApartmentOnboardingPage from './pages/ApartmentOnboardingPage';
import EventsPage from './pages/EventsPage';
import Faq from './feature/Faq/Faq';
import EventDetail from './feature/Events/EventDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import TermAndCondition from './pages/TermAndCondition';
import PricingPolicy from './pages/PricingPolicy';
import Camps from './feature/Camps/Camps';
import CoursePurchasedPage from './pages/CoursePurchasedPage';
import CourseDetailOfTypeSixPage from './pages/CourseDetailOfTypeSixPage';
import FinalPriveTypeFivePage from './pages/FinalPriveTypeFivePage';
import CompetetionCourseListingPage from './pages/CompetetionCourseListingPage';
import CompetitionPollingPage from './pages/CompetitionPollingPage';
import CompetionResultPage from './pages/CompetionResultPage';
import ApartmentSignUpPage from './pages/ApartmentSignUpPage';
import ApartmentLoginPage from './pages/ApartmentLoginPage';
import ConfirmMobilePage from './pages/ConfirmMobilePage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SelectLoginPathPage from './pages/SelectLoginPathPage';
import SelectSignupPathPage from './pages/SelectSignupPathPage';
import AboutUs from './feature/AboutUs/AboutUs';
import SheInspire from './feature/SheInspire/SheInspire';
import Home from './feature/Home/Home';
import TrainerUserLoginPage from './pages/TrainerUserLoginPage';
import TrainerUserSignUpPage from './pages/TrainerUserSignUpPage';
import StudentUserSignUpPage from './pages/StudentUserSignUpPage';
import StudentUserLoginPage from './pages/StudentUserLoginPage';
import EmployeeUserLoginPage from './pages/EmployeeUserLoginPage';
import SchoolUserLoginPage from './pages/SkillVationAuthPages/SchoolUserLoginPage';
import SchoolUserSignPage from './pages/SkillVationAuthPages/SchoolUserSignPage';
import TeacherUserLoginPage from './pages/SkillVationAuthPages/TeacherUserLoginPage';
import TeacherUserSignUpPage from './pages/SkillVationAuthPages/TeacherUserSignUpPage';
import CallbackPage from './pages/CallbackPage';
import SkillBoxPage from './pages/SkillBoxPage';
import SkillFourTeacherPage from './pages/SkillFourTeacherPage';
import SkillBoxProductDetailPage from './pages/SkillBoxProductDetailPage';
import SkillBoxCartPage from './pages/SkillBoxCartPage';
import EducationForLife from './feature/EducationForLife/EducationForLife';
import AiEdge from './feature/AiEdge/AiEdge';
import SummerCamp from './feature/SummerCamp/SummerCamp';
import SkilltoSkillBox from './pages/SkilltoSkillBox';
import WishListPage from './pages/wishListPage';
import ActivityLMSPurchase from './pages/ActivityLMSPurchase';


export const AppRoutes = [
	{
		path: "/",
		Component: Home,
		isProtected: false,
	},
	{
		path: "/ContactUs",
		Component: ContactUsPage,
		isProtected: false,
	},
	{
		path: "/Courses/:category?",
		Component: CoursesPage,
		isProtected: false,
	},
	{
		path: "/CoursesDetail/:slug/:apartments_id?/:title?/:apartment?",
		Component: CourseDetailPage,
		isProtected: false,
	},
	{
		path: "/NewCoursesDetail/:slug?/:apartments_id?",
		Component: CoursePurchasedPage,
		isProtected: false,
	},
	{
		path: "/Apartmentonboarding",
		Component: ApartmentOnboardingPage,
		isProtected: false,
	},
	{
		path: "/Events",
		Component: EventsPage,
		isProtected: false,
	},
	{
		path: "/About",
		Component: AboutUs,
		isProtected: false,
	},
	{
		path: "/Faq",
		Component: Faq,
		isProtected: false,
	},
	{
		path: "/EventDetail/:id/:apartment?/:title?",
		Component: EventDetail,
		isProtected: false,
	},
	{
		path: "/PrivacyPolicy",
		Component: PrivacyPolicy,
		isProtected: false,
	},
	{
		path: "/RefundPolicy",
		Component: RefundPolicy,
		isProtected: false,
	},
	{
		path: "/ShippingPolicy",
		Component: ShippingPolicy,
		isProtected: false,
	},
	{
		path: "/TermAndCondition",
		Component: TermAndCondition,
		isProtected: false,
	},
	{
		path: "/PricingPolicy",
		Component: PricingPolicy,
		isProtected: false,
	},
	{
		path: "/SkillToSchool",
		Component: Camps,
		isProtected: false,
	},
	{
		path: "/SheInspire",
		Component: SheInspire,
		isProtected: false,
	},
	{
		path: "/PurchaseDetail",
		Component: CoursePurchasedPage,
		isProtected: false,
	},
	{
		path: "/OnlineCourseDetail/:slug",
		Component: CourseDetailOfTypeSixPage,
		isProtected: false,
	},
	{
		path: "/FinalPriceDestribution",
		Component: FinalPriveTypeFivePage,
		isProtected: false,
	},
	{
		path: "/CompetitionCourses",
		Component: CompetetionCourseListingPage,
		isProtected: false,
	},
	{
		path: "/PollingOfCompetition",
		Component: CompetitionPollingPage,
		isProtected: false,
	},

	{
		path: "/PollingResult",
		Component: CompetionResultPage,
		isProtected: false,
	},

	{
		path: "/SkilltoPreskool",
		Component: SkillBoxPage,
		isProtected: false,
	},

	{
		path: "/activitylms/:id",
		Component: ActivityLMSPurchase,
		isProtected: false,
	},

	{
		path: "/ProductDetails/:id",
		Component: SkillBoxProductDetailPage,
		isProtected: false,
	},

	{
		path: "/Cartpage",
		Component: SkillBoxCartPage,
		isProtected: false,
	},

	{
		path: "/SkillBox",
		Component: SkilltoSkillBox,
		isProtected: false,
	},

	{
		path: "/Wishlist",
		Component: WishListPage,
		isProtected: false,
	},

	{
		path: "/SkillFourTeachers",
		Component: SkillFourTeacherPage,
		isProtected: false,
	},
	{
		path: "/EducationForLife",
		Component: EducationForLife,
		isProtected: false,
	},
	{
		path: "/AiEdge",
		Component: AiEdge,
		isProtected: false,
	},
	{
		path: "/SummerCamp",
		Component: SummerCamp,
		isProtected: false,
	},

];

export const AuthRoutes = [
	{ path: '/ApartmentSignUp', Component: ApartmentSignUpPage },
	{ path: '/ApartmentLogin', Component: ApartmentLoginPage },
	{ path: '/ConfirmMobile/:role?', Component: ConfirmMobilePage },
	{ path: '/ResetPassword/:token?/:phone?/:role?', Component: ResetPasswordPage },
	{ path: '/SelectLoginPath', Component: SelectLoginPathPage },
	{ path: '/SelectSignupPath', Component: SelectSignupPathPage },
	{ path: '/TrainerSignUp', Component: TrainerUserSignUpPage },
	{ path: '/TrainerLogin', Component: TrainerUserLoginPage },
	{ path: '/StudentSignUp', Component: StudentUserSignUpPage },
	
	{ path: '/StudentLogin', Component: StudentUserLoginPage },
	{ path: '/EmployeeLogin', Component: EmployeeUserLoginPage },
	{ path: '/login', Component: SchoolUserLoginPage },
	{ path: '/SchoolSignUp', Component: SchoolUserSignPage },
	{ path: '/TeacherLogin', Component: TeacherUserLoginPage },
	{ path: '/TeacherSignUp', Component: TeacherUserSignUpPage },
	{ path: '/callback', Component: CallbackPage },
];


